<template>
  <div class="footer noprint">
    <div class="contact">
      <div class="contactUs item">
          <div class="title">聯絡我們</div>
          <a href="tel:+886-6-2266-300">(06)2266-300</a>
          <a href="tel:+886-0986669288">專線電話：0986-669-288</a>
          <a href="mailto:tw9999tw9999@gmail.com">kingdom9999168@gmail.com</a>
          <div class="address">台南市中西區西門路二段263號</div>
      </div>
      <div class="helpDes item">
          <div class="title">幫助說明</div>
          <div class="footerHelp" v-on:click="paymentRouter">購買與付款</div>
          <div class="footerHelp" v-on:click="shippingRouter">出貨與物流</div>
          <div class="footerHelp" v-on:click="takebackRouter">回售機制與流程</div>
          <div class="footerHelp" v-on:click="goldpriceRouter">標準貴金屬重量計算方式</div>
      </div>
      <div class="addLine item">
          <div class="title">加入我們的 Line 詢問資訊</div>
          <div class="line_id">ID: @nxf8131i</div>
          <img src="https://qr-official.line.me/L/M25Jjb7obw.png">
          <div class="line_id">或洽詢我們的臉書粉專</div>
          <img src="@/images/fbqrcode.jpg">
      </div>
    </div>
    <div class="copyright">
      金牌王國 版權所有&copy; 2018
      <div class="service_privacy">
        <router-link to="/gold/terms_of_service">服務條款</router-link>
        <router-link to="/gold/privacy_policy">隱私政策</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeFooter",
  data() {
    return {
      deviceSize: ""
    };
  },
  created() {
    this.deviceSize = document.body.clientWidth;
  },
  methods: {
    paymentRouter() {
      if (this.deviceSize > 585) {
        this.$router.push("/gold/service/service_payment");
      } else {
        this.$router.push("/gold/service_mobile/service_payment");
      }
    },
    shippingRouter() {
      if (this.deviceSize > 585) {
        this.$router.push("/gold/service/service_shipping");
      } else {
        this.$router.push("/gold/service_mobile/service_shipping");
      }
    },
    takebackRouter() {
      if (this.deviceSize > 585) {
        this.$router.push("/gold/service/service_takeback");
      } else {
        this.$router.push("/gold/service_mobile/service_takeback");
      }
    },
    goldpriceRouter() {
      if (this.deviceSize > 585) {
        this.$router.push("/gold/service/service_goldprice");
      } else {
        this.$router.push("/gold/service_mobile/service_goldprice");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  background-color: $primaryDeepColor;
  color: $secondaryColor3;
  padding: 30px;
  .contact {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    @include phone {
      grid-template-columns: 1fr;
      grid-gap: 20px;
    }
    @include table {
      grid-template-columns: 1fr;
      grid-gap: 20px;
    }
    justify-items: center;
    width: 80%;
    margin: 0 auto 50px auto;
  }
  .item {
    font-size: 15px;
    line-height: 32px;
    text-align: left;
    @include phone {
      text-align: center;
    }
    @include table {
      text-align: center;
    }
  }
  a {
    display: block;
    color: $secondaryColor3;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .title {
    font-weight: bold;
    font-size: 17px;
  }
  .addLine {
    img {
      width: 90px;
    }
  }
  .copyright {
    display: inline;
    .service_privacy {
      display: inline;
      padding-left: 10px;
      @include betweenPhoneTable {
        display: inline-block;
      }
    }
    a {
      display: inline-block;
      padding: 0 5px;
      text-decoration: underline;
    }
  }
  .footerHelp {
    cursor: pointer;
  }
}
</style>
